module.exports = __webpack_public_path__ + "img/logo-orange.795cab99.png";